"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Imagetext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bricksParagraph = require("@titelmedia/bricks-paragraph");
var _styles = require("./styles");
var _bricksUtils = require("@titelmedia/bricks-utils");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ImageItem = ({
  image,
  mobile
}) => {
  const isUseMobileImage = !!mobile;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_styles.ImageContent, {
    showOnlyOnDesktop: isUseMobileImage
  }, _react.default.createElement(_styles.Image, {
    src: image.src,
    srcSet: image.srcSet
  })), mobile && _react.default.createElement(_styles.ImageContent, {
    mobile: true
  }, _react.default.createElement(_styles.Image, {
    src: mobile.src,
    srcSet: mobile.srcSet
  })));
};
const Imagetext = ({
  headline,
  headlineColor,
  image,
  imageMobile,
  text,
  bodyColor,
  sticky,
  parallax,
  parallaxNumber = 5,
  textWrap,
  fullWidth,
  imageAlignment
}) => {
  const fluid = (image === null || image === void 0 ? void 0 : image.fluid) || (image === null || image === void 0 ? void 0 : image.responsiveImage) || image;
  const mobileFluid = (imageMobile === null || imageMobile === void 0 ? void 0 : imageMobile.fluid) || (imageMobile === null || imageMobile === void 0 ? void 0 : imageMobile.responsiveImage) || imageMobile;
  const wrapperRef = (0, _react.useRef)(null);
  const triggerRef = (0, _react.useRef)(null);
  const textRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (!wrapperRef.current) return;
    if (sticky) {
      _bricksUtils.gsap.matchMedia().add(`(min-width: ${_breakpoints.BREAKPOINTS.sm}px)`, () => {
        _bricksUtils.gsap.effects.sticky(wrapperRef.current, {
          trigger: triggerRef.current,
          endTrigger: textRef.current,
          end: 'bottom 15%'
        });
      });
    }
    if (parallax) {
      _bricksUtils.gsap.matchMedia().add(`(min-width: ${_breakpoints.BREAKPOINTS.sm}px)`, () => {
        _bricksUtils.gsap.effects.parallax(textRef.current, {
          yPercent: parallaxNumber,
          trigger: wrapperRef.current
        });
        _bricksUtils.gsap.effects.parallax(triggerRef.current, {
          yPercent: parallaxNumber * 2,
          trigger: wrapperRef.current
        });
      });
    }
  }, [sticky, parallax, parallaxNumber]);
  return _react.default.createElement(_styles.ImagetextWrapper, {
    ref: wrapperRef,
    fullWidth: fullWidth,
    textWrap: textWrap
  }, _react.default.createElement(_styles.VisualWrapper, {
    textWrap: textWrap,
    aspectRatio: image === null || image === void 0 ? void 0 : image.aspectRatio,
    ref: triggerRef,
    imageAlignment: imageAlignment
  }, image && _react.default.createElement(ImageItem, {
    image: fluid,
    mobile: mobileFluid
  })), _react.default.createElement(_styles.TextContainer, {
    ref: textRef,
    imageAlignment: imageAlignment,
    bodyColor: (bodyColor === null || bodyColor === void 0 ? void 0 : bodyColor.hex) || bodyColor,
    textWrap: textWrap
  }, headline && _react.default.createElement(_styles.Headline, {
    headlineColor: (headlineColor === null || headlineColor === void 0 ? void 0 : headlineColor.hex) || headlineColor,
    dangerouslySetInnerHTML: {
      __html: headline
    }
  }), text && _react.default.createElement(_bricksParagraph.Paragraph, {
    text: text
  })));
};
exports.Imagetext = Imagetext;
//# sourceMappingURL=index.js.map